function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M153.7,72.6V20.8h-19.4v-6.9h46.6v6.9h-19.4v51.9L153.7,72.6L153.7,72.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M212.9,72.6v-6.3c-3.3,4.8-7.8,7.2-13.5,7.2c-2.5,0-4.9-0.5-7-1.4c-2.2-1-3.8-2.2-4.9-3.6 c-1.1-1.5-1.8-3.2-2.2-5.4c-0.3-1.4-0.4-3.7-0.4-6.7V30h7.2v23.6c0,3.8,0.1,6.3,0.4,7.6c0.5,1.9,1.4,3.4,2.9,4.5s3.3,1.6,5.5,1.6 s4.2-0.6,6.1-1.7s3.2-2.6,4-4.5s1.2-4.7,1.2-8.3V30h7.2v42.6H212.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M230.7,72.6V30h6.5v6.1c3.1-4.7,7.6-7,13.6-7c2.6,0,4.9,0.5,7.1,1.4c2.2,0.9,3.8,2.1,4.8,3.6 c1.1,1.5,1.8,3.3,2.2,5.3c0.3,1.3,0.4,3.7,0.4,7v26.2h-7.2V46.7c0-2.9-0.3-5.1-0.8-6.6c-0.6-1.5-1.6-2.6-3-3.5s-3.1-1.3-5-1.3 c-3.1,0-5.7,1-8,2.9c-2.2,2-3.3,5.7-3.3,11.1v23.3C238,72.6,230.7,72.6,230.7,72.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M275,76.2l7,1c0.3,2.2,1.1,3.7,2.4,4.7c1.8,1.3,4.2,2,7.3,2c3.3,0,5.9-0.7,7.7-2c1.8-1.3,3-3.2,3.7-5.6 c0.4-1.5,0.5-4.6,0.5-9.3c-3.2,3.7-7.1,5.6-11.8,5.6c-5.9,0-10.4-2.1-13.6-6.3c-3.2-4.2-4.8-9.3-4.8-15.2c0-4.1,0.7-7.8,2.2-11.3 c1.5-3.4,3.6-6.1,6.4-8s6.1-2.8,9.8-2.8c5,0,9.2,2,12.4,6.1V30h6.7v36.8c0,6.6-0.7,11.3-2,14.1c-1.4,2.8-3.5,5-6.4,6.6 s-6.5,2.4-10.8,2.4c-5.1,0-9.2-1.1-12.3-3.4C276.4,84.2,274.9,80.8,275,76.2z M281,50.6c0,5.6,1.1,9.7,3.3,12.2s5,3.9,8.3,3.9 s6.1-1.3,8.3-3.8c2.2-2.6,3.4-6.6,3.4-12c0-5.2-1.2-9.1-3.5-11.8c-2.3-2.6-5.1-4-8.4-4c-3.2,0-5.9,1.3-8.2,3.9 C282.1,41.6,281,45.4,281,50.6z"
}), React.createElement("path", {
  className: "st0",
  d: "M319.2,59.9l7.1-1.1c0.4,2.9,1.5,5.1,3.3,6.6s4.4,2.3,7.7,2.3c3.3,0,5.8-0.7,7.4-2s2.4-2.9,2.4-4.8 c0-1.6-0.7-2.9-2.1-3.9c-1-0.6-3.5-1.5-7.4-2.4c-5.3-1.3-9-2.5-11-3.5s-3.6-2.3-4.7-4.1c-1.1-1.7-1.6-3.6-1.6-5.7 c0-1.9,0.4-3.7,1.3-5.3s2.1-3,3.5-4c1.1-0.8,2.7-1.5,4.6-2.1s4-0.9,6.2-0.9c3.3,0,6.3,0.5,8.8,1.4c2.5,1,4.4,2.3,5.6,3.9 c1.2,1.6,2,3.8,2.5,6.6l-7.1,1c-0.3-2.2-1.3-3.9-2.8-5.1c-1.5-1.2-3.7-1.8-6.5-1.8c-3.3,0-5.7,0.5-7.1,1.6s-2.1,2.4-2.1,3.9 c0,0.9,0.3,1.8,0.9,2.5c0.6,0.8,1.5,1.4,2.8,1.9c0.7,0.3,2.8,0.9,6.4,1.8c5.1,1.4,8.7,2.5,10.7,3.4s3.6,2.1,4.8,3.8 c1.1,1.7,1.7,3.7,1.7,6.2c0,2.4-0.7,4.7-2.1,6.8c-1.4,2.1-3.4,3.8-6.1,4.9c-2.6,1.2-5.6,1.7-9,1.7c-5.5,0-9.8-1.1-12.7-3.5 C321.8,67.8,320,64.4,319.2,59.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M378.9,66.2l1,6.4c-2,0.4-3.9,0.6-5.5,0.6c-2.6,0-4.7-0.4-6.1-1.2c-1.4-0.8-2.5-1.9-3-3.3 c-0.6-1.3-0.9-4.2-0.9-8.5V35.6h-5.3V30h5.3V19.5l7.2-4.3V30h7.3v5.6h-7.3v24.9c0,2.1,0.1,3.4,0.4,4s0.7,1.1,1.2,1.4 c0.6,0.3,1.4,0.5,2.5,0.5C376.5,66.4,377.6,66.4,378.9,66.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M415.1,58.9l7.5,0.9c-1.2,4.4-3.4,7.7-6.5,10.2s-7.2,3.6-12.2,3.6c-6.2,0-11.2-1.9-14.8-5.8 c-3.7-3.8-5.5-9.2-5.5-16.1c0-7.2,1.8-12.7,5.5-16.7s8.5-5.9,14.4-5.9c5.7,0,10.4,1.9,14,5.8s5.4,9.3,5.4,16.4c0,0.4,0,1.1,0,1.9 h-31.8c0.3,4.7,1.6,8.3,4,10.8s5.3,3.7,8.9,3.7c2.6,0,4.9-0.7,6.8-2.1S414,62,415.1,58.9z M391.4,47.2h23.8 c-0.3-3.6-1.2-6.3-2.7-8.1c-2.3-2.8-5.3-4.2-8.9-4.2c-3.3,0-6.1,1.1-8.4,3.3C392.9,40.5,391.7,43.5,391.4,47.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M431.7,72.6V30h6.5v6.1c3.1-4.7,7.6-7,13.6-7c2.6,0,4.9,0.5,7.1,1.4s3.8,2.1,4.8,3.6c1.1,1.5,1.8,3.3,2.2,5.3 c0.3,1.3,0.4,3.7,0.4,7v26.2h-7.2V46.7c0-2.9-0.3-5.1-0.8-6.6c-0.6-1.5-1.6-2.6-3-3.5s-3.1-1.3-5-1.3c-3.1,0-5.7,1-8,2.9 c-2.2,2-3.3,5.7-3.3,11.1v23.3C439,72.6,431.7,72.6,431.7,72.6z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M56.3,80.7c0,1.9,0,3.6,0,5.5c0,1.2-0.6,2.1-1.9,2c-1.2,0-1.9-0.9-1.9-2.1c0-3.5,0-7.2,0-10.7 c0-1.2,0.5-2.1,1.8-2.1c1.4,0,1.9,0.9,1.9,2.2C56.2,77.1,56.3,78.9,56.3,80.7z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M83.7,76.3c-0.7-0.4-1.3-0.8-1.8-1.1c-2.1-2.1-4.2-4.2-6.4-6.4c-1-1-1.4-1.9-0.4-3c1-1,2-0.6,2.9,0.3 c2.2,2.2,4.4,4.3,6.5,6.6c0.4,0.5,0.6,1.6,0.5,2.4C85.2,75.5,84.3,75.8,83.7,76.3z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M22.9,71.7c0.4-0.7,0.6-1.2,1-1.7c1.8-1.9,3.5-3.6,5.3-5.4c0.9-0.9,1.9-1.1,2.9-0.2c0.9,1,0.6,1.9-0.3,2.7 c-1.9,1.9-3.6,3.7-5.5,5.4c-0.5,0.4-1.5,0.6-2.2,0.4C23.8,73,23.5,72.2,22.9,71.7z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M18.6,44.9c-1.2,0-2.5,0-3.7,0c-1.1,0-1.9-0.6-1.9-1.9c0-1.2,0.7-1.9,1.9-1.9c2.6-0.1,5-0.1,7.6,0 c1.1,0,2,0.9,1.8,1.9c-0.2,0.7-1.1,1.5-1.9,1.7C21.2,45,19.8,44.9,18.6,44.9z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M90.1,44.9c-1.2,0-2.5,0-3.7,0s-2-0.8-1.9-1.9c0.1-0.7,1.1-1.8,1.7-1.8c2.6-0.2,5.1-0.2,7.8,0 c0.6,0.1,1.5,1.1,1.7,1.9c0.3,1.1-0.7,1.8-1.9,1.9C92.6,44.9,91.4,44.9,90.1,44.9z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M32.2,21c-0.3,0.4-0.5,1.1-1,1.3c-0.6,0.3-1.7,0.3-2.1-0.1c-1.9-1.8-3.8-3.6-5.6-5.6c-0.4-0.4-0.4-1.7,0.1-2.2 c0.4-0.4,1.8-0.8,2.1-0.5c2.2,1.9,4.2,4.1,6.3,6.2C32.1,20.2,32.1,20.5,32.2,21z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M82.9,15.1c0,1.5-4.7,6.3-5.9,6.1c-0.5-0.1-1.3-0.5-1.5-1c-0.3-0.5-0.2-1.5,0.2-1.9c1.3-1.5,2.8-3,4.3-4.3 c0.4-0.4,1.3-0.4,1.9-0.1C82.5,14.2,82.7,14.9,82.9,15.1z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M40,5.4c9.6,0,19.1,0,28.7,0c0,1.9,0.1,3.9,0,5.7c-0.2,4.6,1,8.9,3,13.1c1.8,3.6,3.6,7.2,5,10.9 c2.6,7.5,2.6,15-1.4,22.2c-5.1,9.3-16.1,13.8-26.7,11.2c-11.1-2.7-18.4-12.4-18-24c0.2-4.9,1.3-9.6,3.4-14c1.2-2.6,2.6-5.1,3.7-7.7 c1.7-3.4,2.6-7.1,2.4-11C39.9,9.8,40,7.7,40,5.4z M44.2,9.4c-0.2,2.9-0.3,5.7-0.6,8.3c-0.7,5-3.2,9.4-5.4,13.7 c-1.8,3.5-3.1,7.1-3.6,11.1c-1.1,8.2,2.7,16.4,9.8,20.3c7.3,4.1,17.2,3.1,23.3-2.4c6.7-6.1,8-13.9,5.5-22.2 c-1.2-4.1-3.3-7.8-5.1-11.7c-2.2-4.7-3.4-9.6-3.4-14.7c0-0.8,0-1.5,0-2.3C57.7,9.4,51,9.4,44.2,9.4z"
});

var SvgTungstenIcon = function SvgTungstenIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482.1 93",
    style: {
      enableBackground: "new 0 0 482.1 93"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTungstenIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tungsten-icon.5ff52569.svg";
export { ForwardRef as ReactComponent };